import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './NewsletterSignup.css';

const NewsletterSignup = ({ variant = 'section' }) => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }

    setLoading(true);
    // Placeholder: connect to backend API when ready
    // await api.subscribeNewsletter({ email });

    setTimeout(() => {
      setStatus('success');
      setEmail('');
      setLoading(false);
    }, 800);
  };

  if (variant === 'inline') {
    return (
      <form onSubmit={handleSubmit} className="newsletter-inline" aria-label="Newsletter signup">
        <input
          type="email"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setStatus(''); }}
          placeholder="Enter your email"
          required
          aria-label="Email address for newsletter"
          className="newsletter-input-inline"
        />
        <button type="submit" disabled={loading} className="newsletter-btn-inline" aria-label="Subscribe to newsletter">
          {loading ? '...' : 'Subscribe'}
        </button>
        {status === 'success' && <span className="newsletter-msg-inline" role="status">Thanks for subscribing!</span>}
        {status === 'error' && <span className="newsletter-msg-inline error" role="alert">Please enter a valid email.</span>}
      </form>
    );
  }

  return (
    <section className="newsletter-section" aria-label="Newsletter signup">
      <div className="container">
        <motion.div
          className="newsletter-box"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="newsletter-text">
            <h2>Get New Paintings First</h2>
            <p>Join 500+ art lovers. Be the first to see new artworks, exclusive auctions, and behind-the-scenes studio updates.</p>
          </div>
          <form onSubmit={handleSubmit} className="newsletter-form" aria-label="Newsletter subscription form">
            <div className="newsletter-input-wrapper">
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setStatus(''); }}
                placeholder="your@email.com"
                required
                aria-label="Email address for art updates"
                className="newsletter-input"
              />
              <button type="submit" disabled={loading} className="newsletter-btn" aria-label="Subscribe to art updates">
                {loading ? 'Subscribing...' : 'Notify Me'}
              </button>
            </div>
            {status === 'success' && (
              <p className="newsletter-success" role="status">
                Welcome aboard! Check your inbox for a confirmation.
              </p>
            )}
            {status === 'error' && (
              <p className="newsletter-error" role="alert">
                Please enter a valid email address.
              </p>
            )}
            <p className="newsletter-disclaimer">No spam. Unsubscribe anytime. We respect your privacy.</p>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default NewsletterSignup;
